import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowBoldUpFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9.996,1.413c-.479-.628-1.514-.628-1.992,0L3.011,7.994c-.289,.38-.336,.883-.124,1.311,.213,.429,.642,.695,1.12,.695h1.993v5.25c0,.965,.785,1.75,1.75,1.75h2.5c.965,0,1.75-.785,1.75-1.75v-5.25h1.993c.479,0,.907-.266,1.12-.695,.212-.428,.165-.931-.124-1.311L9.996,1.413Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconArrowBoldUpFill18.js.map